import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Login.css';

import loginWindow from '../assets/loginWindow.png';
import closeBtn from '../assets/loginCloseButton.png';
import inputField from '../assets/loginButtonInput.png';
import continueBtn from '../assets/loginContinueButton.png';
import expandedLoginWindow from '../assets/loginExpandedWindow.png';
import helpImage from '../assets/helpExample.png';

import { trackEvent } from '../utils/Analytics';

function Login({ onClose, prefillId = '', handleContinue ,loginErrorMessage, loading}) {
    const { t } = useTranslation();
    const [userId, setUserId] = useState(prefillId);
    const [isExpanded, setIsExpanded] = useState(false);
    
    const toggleHelp = () => {
        trackEvent('login_help_click', 'login', 'Help Text');
        setIsExpanded(prev => !prev);
    };
    
   
    return (
        <div className="login-overlay">
            <div className={`login-container ${isExpanded ? 'expanded' : ''}`}>
                <div
                    className="login-bg"
                    style={{
                        backgroundImage: `url(${isExpanded ? expandedLoginWindow : loginWindow})`
                    }}
                ></div>
                <img
                    src={closeBtn}
                    alt="Close"
                    className="login-close-btn"
                    onClick={() => {
                        trackEvent('login_close_click', 'login', 'Close Button');
                        onClose(false);
                    }}
                />
                {(
                    <>
                        <div className="input-wrapper">
                            <img src={inputField} alt="Input Field" className="input-bg" />
                            <input
                                type="text"
                                className="real-input"
                                placeholder=""
                                value={userId}
                                onChange={(e) => setUserId(e.target.value)}
                                aria-label={t('login.enterId')}
                            />
                        </div>
                        
                    </>
                )}

                <div className="login-title">{t('login.enterId')}</div>

                {loginErrorMessage !== "" && (
                    <div className="login-message">{loginErrorMessage}</div>
                )}

                <img
                    src={continueBtn}
                    alt="Continue"
                    className={`continue-btn`}
                    onClick={() => {
                        if (!loading) {
                            trackEvent('login_continue_button_click', 'engagement', 'Login Continue Button');
                            handleContinue(userId);
                        }
                    }}
                />

                
                <div className="login-help-text" onClick={toggleHelp} style={{ cursor: 'pointer' }}>
                    {t('login.helpText')}
                </div>
                

                {isExpanded && (
                    <div className="login-help-section">
                        <div className="login-help-caption">
                            {t('login.helpCaption')}
                        </div>
                        <img src={helpImage} alt="Help Example" className="login-help-image" />
                    </div>
                )}
            </div>

            {loading && (
                <div className="login-loading-overlay">
                    <div className="spinner"></div>
                </div>
            )}
        </div>
    );
}

export default Login;
